import React from 'react';
import withBlockExtensions from '@plone/volto/helpers/Extensions/withBlockExtensions';
import DefaultView from './DefaultView';
import type { MainContentReaderBlockData } from './index';

interface Props {
  data: MainContentReaderBlockData;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

const View: React.FC<Props> = ({ data, className, style }) => {
  return (
    <DefaultView align={data?.align} className={className} style={style} />
  );
};

export default withBlockExtensions(View);
